export default __webpack_public_path__ + "static/media/polygon_down.23b7c745.svg";